import gql from "graphql-tag";
import { AVAILABILITY_FRAGMENT } from "@components/ProductPage/ProductThumbnail/queries";
import { VARIANT_FRAGMENT } from "@src/pages/Cart/queries";

export enum RecommendType {
  Brand = "brand",
  Order = "order",
  User = "user",
}

export const SITE = gql`
  query site {
    shop {
      pointRatioForOrder
      firstReviewRewardAmount
    }
  }
`;

export const PRODUCT = gql`
  ${AVAILABILITY_FRAGMENT}
  ${VARIANT_FRAGMENT}
  query product($id: ID!) {
    product(id: $id) {
      id
      name
      isPublished
      isOnWishlist
      url
      urlForGraphql
      brand
      video
      countryOfOrigin
      publicationDate
      seoTitle
      seoDescription
      extraInformation
      isUserBlockedProductReview
      thumbnail {
        url
        alt
      }
      brandLink {
        id
        name
        url
      }
      productType {
        id
        name
        isCodRestricted
        hasVariants
        isMgs
      }
      category {
        id
        name
        level
        url
        parent {
          id
          name
          level
          url
          parent {
            id
            name
            level
            url
          }
        }
      }
      availability {
        ...availability
      }
      variants {
        ...variant
        bigImages: images {
          id
          sortOrder
          url(size: 1080)
        }
        smallImages: images {
          id
          sortOrder
          url(size: 60)
        }
        images {
          id
          sortOrder
          url(size: 255)
        }
      }
      descriptions {
        key
        description
        sortOrder
      }
      descriptionImages {
        id
        url(size: 1800)
        mobileOriginImages: url(size: 1200)
        placeholderImages: url(size: 120)
        alt
        sortOrder
      }
      productReviewsByUser {
        id
        status
        updatedAt
      }
      tags {
        id
        name
      }
      seller {
        id
        name
        address
      }
      price {
        amount
      }
      productReviewsAggregation {
        id
        rating
        reviewCount
        oneStars
        twoStars
        threeStars
        fourStars
        fiveStars
      }
      seoImages: images {
        id
        url(size: 510)
        alt
      }
      bigImages: images {
        id
        sortOrder
        url(size: 1080)
        alt
      }
      smallImages: images {
        id
        sortOrder
        url(size: 60)
        alt
      }
      images {
        id
        sortOrder
        url(size: 255)
        alt
      }
      freebieEvents {
        id
        name
      }
      availableVouchers {
        id
        name
        discountValue
        discountValueType
      }
      notifyStatus
    }
  }
`;
